import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const systemDashboardEditRoute: InvariantJiraRoute = {
	name: 'system-dashboard-edit',
	path: '/secure/admin/EditDefaultDashboard(!default)?.jspa',
	query: ['maximized?'],
};
